import React from "react";
import PuntajeObjetivo from "./PuntajeObjetivo";
import PuntajeCapacitaciones from "./PuntajeCapacitaciones";
import PuntajeTrivias from "./PuntajeTrivias";

import calendar from '../../assets/estrella.png'

function getCategoryList(props) {
  var categoryList = [];

  if (props.user.uy) {
    if (props.period >= 202307) {
      categoryList.push({position: 0, sap: ['1902'], name: "Venta Sell Out", tipo: "1"});
      categoryList.push({position: 1, sap: ['2015'], name: "Compradores Salsas Base Knorr", tipo: "2"});
      categoryList.push({position: 2, sap: ['2018'], name: "Compradores Rinde Más Knorr", tipo: "2"});
      categoryList.push({position: 3, sap: ['2017'], name: "Compradores Sopas Crema Knorr", tipo: "2"});
    } else if (props.period >= 202304) {
      categoryList.push({position: 0, sap: ['1902'], name: "Venta Sell Out", tipo: "1"});
      categoryList.push({position: 1, sap: ['2015'], name: "Compradores Salsas Base Knorr", tipo: "2"});
      categoryList.push({position: 2, sap: ['2016'], name: "Compradores Tomate en Polvo Knorr", tipo: "2"});
      categoryList.push({position: 3, sap: ['2017'], name: "Compradores Sopas Crema Knorr", tipo: "2"});
    } else if (props.period >= 202301) {
      categoryList.push({position: 0, sap: ['1902'], name: "Venta Sell Out", tipo: "1"});
      categoryList.push({position: 1, sap: ['2011'], name: "Compradores Mayonesa Hellmanns BLS", tipo: "2"});
      categoryList.push({position: 2, sap: ['2012'], name: "Compradores Salad Dressing", tipo: "2"});
      categoryList.push({position: 3, sap: ['2014'], name: "Compradores Rebozador", tipo: "2"});
    } else if (props.period >= 202210) {
      categoryList.push({position: 0, sap: ['1902'], name: "Venta Sell Out", tipo: "1"});
      categoryList.push({position: 1, sap: ['2011'], name: "Compradores Mayonesa Hellmanns BLS", tipo: "2"});
      categoryList.push({position: 2, sap: ['2012'], name: "Compradores Salad Dressing", tipo: "2"});
      categoryList.push({position: 3, sap: ['2013'], name: "Compradores Knorr", tipo: "2"});
    } else if (props.period >= 202207) {
      categoryList.push({position: 0, sap: ['1902'], name: "Ventas Sell Out", tipo: "1"});
      categoryList.push({position: 1, sap: ['1904'], name: "Compradores Sell Out", tipo: "2"});
      categoryList.push({position: 2, sap: ['1905'], name: "Compradores Knorr", tipo: "2"});
    } else if (props.period >= 202205) {
      categoryList.push({position: 0, sap: ['1902'], name: "UFS", tipo: "1"});
      categoryList.push({position: 1, sap: ['1904'], name: "Bonushero Reach Porciones Hellmanns", tipo: "2"});
      categoryList.push({position: 2, sap: ['1905'], name: "Bonushero Reach Sopas Knorr", tipo: "2"});
    } else if (props.period >= 202201) {
      categoryList.push({position: 0, sap: ['1902'], name: "Food Solutions", tipo: "1"});
      categoryList.push({position: 1, sap: ['1904'], name: "Bonushero Reach Porciones Hellmanns", tipo: "2"});
      categoryList.push({position: 2, sap: ['1903'], name: "Bonushero Reach Carte D'Or", tipo: "2"});
    } else {
      categoryList.push({position: 0, sap: ['1901', '1902'], name: "Food Solutions", tipo: "3"});
      categoryList.push({position: 1, sap: ['1900'],         name: "Hellmann's + Savora", tipo: "2"});
    }
  } else {
    if (props.period >= 202401) {
      categoryList.push({position: 0, sap: ['1007'], name: "UFS", tipo: "1"});
      categoryList.push({position: 1, sap: ['1607'], name: "Bolsas Premium", tipo: "2"});
      categoryList.push({position: 2, sap: ['1707'], name: "Porciones Premium", tipo: "2"});
      categoryList.push({position: 3, sap: ['1809'], name: "Postres Carte D'Or", tipo: "2"});
    } else if (props.period >= 202307) {
      categoryList.push({position: 0, sap: ['1007'], name: "UFS", tipo: "1"});
      categoryList.push({position: 1, sap: ['1607'], name: "Bolsas Premium", tipo: "2"});
      categoryList.push({position: 2, sap: ['1707'], name: "Porciones Premium", tipo: "2"});
      categoryList.push({position: 3, sap: ['1807'], name: "Tomate deshidratado", tipo: "2"});
    } else if (props.period >= 202304) {
      categoryList.push({position: 0, sap: ['1700'], name: "UFS", tipo: "1"});
      categoryList.push({position: 1, sap: ['2001'], name: "Total Sell Out", tipo: "2"});
      categoryList.push({position: 2, sap: ['1014'], name: "Bolsas Premium", tipo: "2"});
      categoryList.push({position: 3, sap: ['1015'], name: "Salsa Blanca", tipo: "2"});
    } else if (props.period >= 202212) {
      categoryList.push({position: 0, sap: ['1700'], name: "UFS", tipo: "1"});
      categoryList.push({position: 1, sap: ['2001'], name: "Total Sell Out", tipo: "2"});
      categoryList.push({position: 2, sap: ['2002'], name: "Tomate Deshidratado Knorr", tipo: "2"});
      categoryList.push({position: 3, sap: ['2004'], name: "Rebozador", tipo: "2"});
    } else if (props.period >= 202210) {
      categoryList.push({position: 0, sap: ['1700'], name: "UFS", tipo: "1"});
      categoryList.push({position: 1, sap: ['2001'], name: "Total Sell Out", tipo: "2"});
      categoryList.push({position: 2, sap: ['2002'], name: "Tomate Deshidratado Knorr", tipo: "2"});
      categoryList.push({position: 3, sap: ['2003'], name: "Mayonesa Hellmanns Vegana", tipo: "2"});
    } else if (props.period >= 202205) {
      categoryList.push({position: 0, sap: ["1700"], name: "Food Solutions", tipo: "1"});
      categoryList.push({position: 1, sap: ["1010"], name: "Dressing core", tipo: "2"});
      categoryList.push({position: 2, sap: ["1012"], name: "Knorr Productos Estratégicos", tipo: "2"});
      categoryList.push({position: 3, sap: ["1013"], name: "Postres Carte D'Or", tipo: "2"});
    } else if (props.period >= 202110) {
      categoryList.push({position: 0, sap: ["1700"], name: "Food Solutions", tipo: "1"});
      categoryList.push({position: 1, sap: ["1010", "1011"], name: "Dressing core", tipo: "3"});
      categoryList.push({position: 2, sap: ["1012"], name: "Knorr Productos Estratégicos", tipo: "2"});
      categoryList.push({position: 3, sap: ["1013"], name: "Postres Carte D'Or", tipo: "2"});
    } else if (props.period >= 202109) {
      categoryList.push({position: 0, sap: ["1700", "1800"], name: "Food Solutions", tipo: "3"});
      categoryList.push({position: 1, sap: ["1001"], name: "Hellmann's", tipo: "1"});
      categoryList.push({position: 2, sap: ["1002"], name: "Barbacoa Hellmann's", tipo: "2"});
      if (props.user.professional) {
        categoryList.push({position: 3, sap: ["1003"], name: "Línea Profesional", tipo: "1"});
      }
    } else {
      categoryList.push({position: 0, sap: ["1700", "1800"], name: "Food Solutions", tipo: "3"});
      categoryList.push({position: 1, sap: ["1001"], name: "Hellmann's", tipo: "1"});
      if (props.user.professional) {
        categoryList.push({position: 3, sap: ["1003", "1004"], name: "Línea Profesional", tipo: "3"});
      }
    }
  }
  return categoryList;
}

function getTotalPoints(props) {
  var total = 0;
  var aux1 = props.points;
  for (var i = 0; i < aux1.length; i++) {
    if (aux1[i]) {
      total += aux1[i]['amount'];
    }
  }  
  return total;
}

function getBounsPoints(props) {
  var total = 0;
  var aux1 = props.points;
  for (var i = 0; i < aux1.length; i++) {
    if (aux1[i] && aux1[i]['type'] === 'Bonus') {
      total += aux1[i]['amount'];
    }
  }  
  return total;
}

function getLevel(user, total) {
  const LEVELS = ["","Inicial", "Pro", "Superpro"];
  const FACTORS = [0, 1, 1.2, 1.4];

  var level;
  
  if (user.type === 2) {
    // Vendedor
    if (total >= 30000) {
      level = 3;
    } else if (total >= 15000) {
      level = 1.2;
    } else {
      level = 1;
    }
  } else {
    // Supervisor
    if (total >= 42000) {
      level = 3;
    } else if (total >= 21000) {
      level = 2;
    } else {
      level = 1;
    }
  }
  return {'id': level, 'name': LEVELS[parseInt(level, 10)], 'factor': FACTORS[parseInt(level, 10)]};
}

const Render = (props) => {
  const categoryList = getCategoryList(props);
  const capTypes = ["Capacitacion", "Supervisor-Capacitacion"];
  const triTypes = ["Trivia", "Supervisor-Trivia"];
  const total = getTotalPoints(props);
  const bonus = getBounsPoints(props);
  const level = getLevel(props.user, total);
  const prize = total * level.factor;
  
  return (
    <div className="row item">
      <div className="col-10 offset-1">
        <div className="meses">
          <div className="row mt-70">
            <div className="col-md-12">
              <div className="row textContenedor dflex justify-content-center align-items-center box_sombra">
                <img
                  src={calendar}
                  className="mt-60"
                  height="117"
                  width="126"
                  alt={props.periodo}
                />
                <div className="col-md-12 mb-60">
                  <h3 className="white alignCenter mbn">{props.periodo}</h3>
                </div>
              </div>
            </div>
          </div>
  				<div className="row box_sombra">
            {categoryList.map(category => (
              <PuntajeObjetivo
                key={("PO-"+props.id+"-"+category.position)}
                id={("PO-"+props.id+"-"+category.position)}
                category={category} 
                goals={props.goals.filter(goal => {return category.sap.indexOf(goal.product.sap) >= 0;})}
                points={props.points} />
            ))}
            <PuntajeTrivias points={props.points.filter(point => {return triTypes.indexOf(point.type) >= 0;})} />
            <PuntajeCapacitaciones points={props.points.filter(point => {return capTypes.indexOf(point.type) >= 0;})} />
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="row textContenedorFondo dflex justify-content-start align-items-center box_sombra">
                  <div className="col-lg">
                    <h4 className="white">PUNTOS TOTALES GANADOS</h4>
                    <p className="white avenirL">{total} pts.</p>
                  </div>
                  <div className="col-lg">
                    <h4 className="white">BONUS TRACK</h4>
                    <p className="white avenirL">{bonus} pts.</p>
                  </div>
                  <div className="col-lg">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="white">PREMIO</h4>
                        <p className="white avenirL">$ {prize}</p>
                      </div>
                      <div className="col-6">
                        <h4 className="white">NIVEL</h4>
                        <p className="white avenirL">{level.name}</p>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </div>	
        </div>
      </div>
    </div>
  );
};

Render.contextTypes = {};

export default Render;



// WEBPACK FOOTER //
// ./src/pages/Home/PuntosDelMes.js